import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HrefResolverService, ServicePathProviderService } from '@blk/cwp-ng-framework';
import { Observable } from 'rxjs';

import { GlsApiResponse } from '../gls/models/gls-api-response';
import { GlsConstants } from './gls.constants';

@Injectable({
	providedIn: 'root'
})
export class GlsService {
	constructor(private _http: HttpClient, private _servicePathProviderService: ServicePathProviderService, private hrefResolverService: HrefResolverService) { }

	/**
	 *
	 * @ param documentId
	 * @ param actionType
	 * @ returns {any}
	 */
	public manageDocumentSubscription(documentId: string, actionType: string, currentCsrfToken: string): Observable<GlsApiResponse> {
		let actionIdentifier: string;
		if (actionType === GlsConstants.UNSUBSCRIBE) {
			actionIdentifier = 'remove';
		} else if (actionType === GlsConstants.RESUBSCRIBE) {
			actionIdentifier = 'add';
		}

		const subscriptionUrl = this.hrefResolverService.getResolvedUrl('mySubscriptionUpdate');
		return this._http.post(subscriptionUrl, {
			[actionIdentifier]: [documentId],
			csrfToken: currentCsrfToken
		}) as Observable<GlsApiResponse>;
	}
}
